import Http from '@/services/http';
import store from '@/store';
import { LatestWarningResponse } from 'sigma-mappings';

const configUrl = {
  getNumberNotificationsNotRead: '/NotificacaoRecurso/nao-visualizadas/contagem',
  getListNotification: '/NotificacaoRecurso',
  updateLatestDateVisualization: notificationId => `NotificacaoRecurso/${notificationId}/visualizar`,
};


export default {
  getNumberNotificationsNotRead() {
    const http = new Http();
    return http.get(configUrl.getNumberNotificationsNotRead).then(({ data }) => {
      store.dispatch('setNotification', data.notificacoesNaoLidas);
      return data;
    }).catch((error) => {
      store.dispatch('setErrorNotification');
      return Promise.reject(error);
    });
  },

  getListNotification() {
    const http = new Http();
    return http.get(configUrl.getListNotification)
      .then(({ data }) => data.map(item => new LatestWarningResponse(item)))
      .catch((error) => Promise.reject(error));
  },

  updateLatestVisualization(notificationId) {
    const http = new Http();
    return http.post(configUrl.updateLatestDateVisualization(notificationId))
      .then(() => this.getNumberNotificationsNotRead())
      .catch((error) => Promise.reject(error));
  },
};
